import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension } from '@deck.gl/extensions'

export class StreetCategoryLayer extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    opacity = 100;

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity;
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            new MVTLayer({
                id: 'sumatraStreetCategory1',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 1000

                        default:
                            return 0
                    }
                },

                visible: zoom < 7.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory2',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 700

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 300

                        default:
                            return 0
                    }
                },

                visible: zoom >= 7.5 && zoom < 9.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory3',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        case 16:
                        case 18:
                            return [103, 151, 223]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 200

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 120


                        case 18:
                        case 16:
                            return 75

                        default:
                            return 0
                    }
                },

                visible: zoom >= 9.5 && zoom < 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory4',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        case 16:
                        case 18:
                            return [103, 151, 223]

                        case 5:
                        case 20:
                        case 23:
                            return [82, 86, 190]

                        case 2:
                        case 25:
                            return [82, 86, 190]

                        case 7:
                        case 13:
                        case 21:
                            return [134, 121, 219]

                        case 12:
                            return [79, 167, 126]

                        default:
                            return [100, 100, 100]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 30

                        case 22:
                        case 24:
                        case 14:
                        case 16:
                        case 17:
                        case 18:
                            return 20

                        case 5:
                        case 20:
                        case 23:
                            return 15

                        default:
                            return 3
                    }
                },
                visible: zoom >= 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory5',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 1000

                        default:
                            return 0
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom < 7.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory6',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 700

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 300

                        default:
                            return 0
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 7.5 && zoom < 9.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory7',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        case 16:
                        case 18:
                            return [103, 151, 223]

                        default:
                            return [0, 0, 0]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 200

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 120


                        case 18:
                        case 16:
                            return 75

                        default:
                            return 0
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 9.5 && zoom < 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCategory8',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                stroked: true,
                pickable: true,
                opacity: this.opacity / 100,
                getLineColor: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                            return [255, 0, 0]

                        case 10:
                        case 15:
                            return [255, 152, 82]

                        case 22:
                        case 24:
                            return [225, 182, 73]

                        case 14:
                        case 17:
                            return [123, 216, 255]

                        case 16:
                        case 18:
                            return [103, 151, 223]

                        case 5:
                        case 20:
                        case 23:
                            return [82, 86, 190]

                        case 2:
                        case 25:
                            return [82, 86, 190]

                        case 7:
                        case 13:
                        case 21:
                            return [134, 121, 219]

                        case 12:
                            return [79, 167, 126]

                        default:
                            return [100, 100, 100]
                    }
                },
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 30

                        case 22:
                        case 24:
                        case 14:
                        case 16:
                        case 17:
                        case 18:
                            return 20

                        case 5:
                        case 20:
                        case 23:
                            return 15

                        default:
                            return 3
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 12
            }),
        ]
    }
}